export type SampleLogSnapshot = {
  running: boolean;
  state: "running" | "stopped";
  pid?: number | null;
  last_ok_at?: string | null;
  chargers?: number | null;
  batch_s?: number | null;
  last_error?: string | null;
  block?: string | null;
  table?: string | null;
  error?: string;
};

export async function fetchSampleLog(): Promise<SampleLogSnapshot> {
  const res = await fetch("/api/sample-log", { credentials: "same-origin" });
  const data = (await res.json().catch(() => ({}))) as SampleLogSnapshot & { error?: string };
  if (!res.ok) {
    throw new Error(data.error || `sample log ${res.status}`);
  }
  return data;
}

export async function postSampleLogService(action: "start" | "stop"): Promise<SampleLogSnapshot> {
  const res = await fetch("/api/sample-log/service", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ action }),
  });
  const data = (await res.json().catch(() => ({}))) as SampleLogSnapshot & { error?: string };
  if (!res.ok) {
    throw new Error(data.error || `sample log ${res.status}`);
  }
  return data;
}
